/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `MuseumIconProps` interface defines the properties for the MuseumIcon component.
 */
interface MuseumIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "museum" — outlined, weight 300.
 * Museum icon for the Geschichte (Kunst & Kultur) category.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const MuseumIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'MuseumIcon',
    width
}: MuseumIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M100-100v-60h80v-380h-80v-49.23l380-266.15 380 266.15V-540h-80v380h80v60H100Zm140-60h480-480Zm92.31-90h60v-170L480-289.23 567.69-420v170h60v-260h-62.3L480-382.31 394.61-510h-62.3v260ZM720-160v-454L480-782 240-614v454h480Z" />
    </svg>
);

MuseumIcon.displayName = 'MuseumIcon';